
































import { ITaskForKanban } from '@/api/types/response.types'
import Vue from 'vue'

export default Vue.extend({
  name: 'AddTaskDrawer',

  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    // Default project to select after projects dropdown is loaded
    projectId: {
      type: Number,
      required: true,
    },
    /* Pass thru to add task form drawer for freshness info return on create */
    lastAccessEpochTime: {
      type: Number,
      default: null,
    },
    forKanban: {
      type: Boolean,
      default: false,
    },
    forListing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      closeDrawerOnOutsideClick: true,
      drawerOpened: false,
      showAddTaskPanel: true,
    }
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showDrawer
      },
      set(newValue: boolean) {
        this.$emit('update:showDrawer', newValue)
      },
    },
    drawerWidthPct(): string {
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return '100%'
      }
      return '680px'
    },
  },

  methods: {
    onOpened() {
      this.drawerOpened = true
    },

    onClosed() {
      this.drawerOpened = false
    },

    handleTaskCreatedForKanban(
      taskForKanban: ITaskForKanban,
      createAnother: boolean,
      newEpochTime: number,
    ) {
      if (!this.forKanban) {
        return
      }
      this.$emit('task-created-for-kanban', taskForKanban, newEpochTime)
      if (!createAnother) {
        this.handleCancel()
      }
    },

    handleTaskCreatedForListing(createAnother: boolean, newEpochTime: number) {
      this.$emit('task-created-for-listing', newEpochTime)
      if (!createAnother) {
        this.handleCancel()
      }
    },

    handleCancel() {
      this.$emit('update:showDrawer', false)
    },
  },
})
